import css from './index.module.scss';
import SectionA from './components/SectionA';
import SectionB from './components/SectionB';
import SectionC from './components/SectionC';
import SectionD from './components/SectionD';
import SectionE from './components/SectionE';
import SectionK from './components/SectionK';
import SectionL from './components/SectionL';
import SectionM from './components/SectionM';
import SectionN from './components/SectionN';
import { useGlobal } from '@/utils/useGlobal';

export default function CES() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    return (
        <div className={css.cesWrapper}>
            <SectionA />
            <SectionB />
            {/* <div className="sectionStyle" style={{ padding: 0 }}>
                <SectionC />
            </div> */}

            <div className="sectionStyle">
                <SectionD />
            </div>

            {locale === 'us' && (
                <>
                    <SectionE />
                    <SectionK />
                </>
            )}
            <SectionL />
            <SectionM />
            <SectionN />
        </div>
    );
}
